// 開発環境用設定
const dev = {
  BACKEND_URL: "https://us-central1-lixil-sr360-api-dev.cloudfunctions.net/sr360"
};

//ステージング環境用設定
const test = {
  BACKEND_URL: "https://us-central1-lixil-sr360-api-test.cloudfunctions.net/sr360"
};

//本番環境用設定
const prod = {
  BACKEND_URL: "https://us-central1-lixil-sr360-api-prod.cloudfunctions.net/sr360"
};

function chooseEnvironment(env) {
  switch (env) {
    case "development":
      return dev;
    case "test":
      return test;
    case "production":
      return prod;
    default:
      return prod;
  }
}

const currentEnv = process.env.REACT_APP_STAGE || "development";
const config = chooseEnvironment(currentEnv);

export const BACKEND_URL = config.BACKEND_URL;

// 共通設定
export const DEFAULT_PAGINATION_LIMIT = 10;



// WEBPACK FOOTER //
// ./src/config/constants.js